// pagination.md §4 — the sizes every console list offers. The footer hides
// while everything fits the smallest (§10), so it never yo-yos on a toggle.
export const PAGE_SIZES = [25, 50, 100] as const
export type PageSize = (typeof PAGE_SIZES)[number]
export const DEFAULT_PAGE_SIZE: PageSize = 50

// Mirrors api/admin_listing.py::PAGE_SIZE_MAX: what a caller asks for when
// it needs a whole small list (a wizard step on a new institution).
export const PAGE_SIZE_MAX = 100

// The URL keys of a list (pagination.md §7), Spanish like `vista` and
// `escuela` (url-conventions.md).
export const LIST_PARAM = { q: "q", sort: "orden", page: "pagina", size: "tam" } as const
